import React from 'react';

import FormView from '../formView';
import '../style.sass';

const AddAction = props => (
  <FormView
    {...props}
  />
);

export default AddAction;
